import { render } from "./FormBuilder.vue?vue&type=template&id=242523fb"
import script from "./FormBuilder.vue?vue&type=script&lang=js"
export * from "./FormBuilder.vue?vue&type=script&lang=js"

import exportComponent from "C:\\VS2022\\kirchenbote-online-2022_01\\MD.RMP.KirchenboteOnline.Umb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/multiForms/FormBuilder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "242523fb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('242523fb', __exports__)) {
    api.reload('242523fb', __exports__)
  }
  
  module.hot.accept("./FormBuilder.vue?vue&type=template&id=242523fb", () => {
    api.rerender('242523fb', render)
  })

}


export default __exports__